import React from 'react';

import { useIntl } from 'react-intl-next';

import { Tab, TabList } from '@atlaskit/tabs';

import { messages } from './messages';

type DebuggerTabListProps = {
	isNaturalLanguageQuery: boolean;
	hasMinionOutputs: boolean;
	hasPluginInvocations: boolean;
	roundCount: number;
};

export const DebuggerTabList = ({
	isNaturalLanguageQuery,
	hasMinionOutputs,
	hasPluginInvocations,
	roundCount,
}: DebuggerTabListProps) => {
	const { formatMessage } = useIntl();

	const showPluginsTabs = isNaturalLanguageQuery && !hasMinionOutputs && hasPluginInvocations;

	return (
		<TabList>
			<Tab>{formatMessage(messages.ai_debugger_modal_tab_request_overview)}</Tab>
			{showPluginsTabs && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_raw_search_results)}</Tab>
			)}
			{showPluginsTabs && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_ranked_search_results)}</Tab>
			)}
			{showPluginsTabs && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_plugin_invocations)}</Tab>
			)}
			{isNaturalLanguageQuery && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_orchestration_overview)}</Tab>
			)}
			{isNaturalLanguageQuery &&
				hasMinionOutputs &&
				Array.from({ length: roundCount }, (_, index) => (
					<Tab key={`loop-${index}`}>
						{formatMessage(messages.ai_debugger_modal_tab_loop, { number: index })}
					</Tab>
				))}
			{isNaturalLanguageQuery && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_raw_json)}</Tab>
			)}
		</TabList>
	);
};
